import { type FillApplicationState, FillCard, hasFilesReading } from '@/models/fillApplication'

/** The tabs of the form, in the order Save and continue walks them. */
export enum FillStep {
  DOCUMENTS = 'documents',
  BUSINESS = 'business',
  EQUIPMENT = 'equipment',
  LOSS_RUNS = 'loss_runs',
  COVERAGE = 'coverage',
  CONFIRMATION = 'confirmation',
}

export const FILL_STEPS: FillStep[] = [
  FillStep.DOCUMENTS,
  FillStep.BUSINESS,
  FillStep.EQUIPMENT,
  FillStep.LOSS_RUNS,
  FillStep.COVERAGE,
  FillStep.CONFIRMATION,
]

export const FILL_STEP_LABELS: Record<FillStep, string> = {
  [FillStep.DOCUMENTS]: 'Documents',
  [FillStep.BUSINESS]: 'Business',
  [FillStep.EQUIPMENT]: 'Equipment',
  [FillStep.LOSS_RUNS]: 'Loss runs',
  [FillStep.COVERAGE]: 'Coverage',
  [FillStep.CONFIRMATION]: 'Confirmation',
}

const CARD_STEPS: Record<FillCard, FillStep> = {
  [FillCard.BUSINESS]: FillStep.BUSINESS,
  [FillCard.EQUIPMENT]: FillStep.EQUIPMENT,
  [FillCard.LOSS_RUNS]: FillStep.LOSS_RUNS,
  [FillCard.COVERAGE]: FillStep.COVERAGE,
}

export function stepForCard(card: FillCard): FillStep {
  return CARD_STEPS[card]
}

export function nextStep(step: FillStep, steps: FillStep[] = FILL_STEPS): FillStep {
  const index = steps.indexOf(step)
  return steps[Math.min(index + 1, steps.length - 1)]
}

export function previousStep(step: FillStep, steps: FillStep[] = FILL_STEPS): FillStep {
  const index = steps.indexOf(step)
  return steps[Math.max(index - 1, 0)]
}

/** Where the form opens: the send's outcome once sent, the files while any are read, else the first tab to fill. */
export function defaultStep(state: FillApplicationState): FillStep {
  if (state.sent) return FillStep.CONFIRMATION
  if (hasFilesReading(state)) return FillStep.DOCUMENTS
  return FillStep.BUSINESS
}
